/* Shared memory of the assistant: limits, check verdicts and the author line of an entry. */
import dayjs from 'dayjs';

export const MAX_TEXT = 500;
export const MAX_SUBJECT = 120;
export const MAX_INSTRUCTIONS = 4000;

export const VERDICTS = {
  contradicts: 'противоречит',
  refines: 'уточняет',
  duplicate: 'повторяет',
};

const UNCHECKED = 'Противоречия не проверены: модель недоступна';

/**
 * The entry waits for an administrator's decision on a conflict with another one: a suggestion or an edit
 * (pending), or an archived entry that was not restored because of the conflict (it stays archived).
 */
export function hasConflict(item) {
  return !!(item && item.conflict && (item.status === 'pending' || item.status === 'archived'));
}

/** A check result that needs no decision but is worth a note: a duplicate or a check without the model. */
export function checkNote(check, done = '') {
  if (!check) return null;
  if (check.verdict === 'duplicate') return { tone: 'warning', text: 'Такая запись уже есть в памяти' };
  if (check.verdict === 'unchecked') return { tone: 'warning', text: done ? `${done} ${UNCHECKED}.` : UNCHECKED };
  return null;
}

// Memory timestamps are UTC (ISO): shown in the browser time zone.
export function memoryDate(value) {
  if (!value) return '';
  const moment = dayjs(value);
  return moment.isValid() ? moment.format('DD.MM.YYYY HH:mm') : '';
}

export function authorLabel(id, me) {
  if (id === null || id === undefined) return '';
  return id === me ? 'вы' : `пользователь ${id}`;
}

/** Parts of the author line: «из чата», «вы», «08.10.2026 14:32», «изменено 09.10.2026 10:05». */
export function memoryMeta(item, me) {
  const parts = [];
  if (item.origin === 'chat') parts.push('из чата');
  const author = authorLabel(item.createdBy, me);
  if (author) parts.push(author);
  if (item.createdAt) parts.push(memoryDate(item.createdAt));
  if (item.updatedAt && item.updatedAt !== item.createdAt) {
    const editor = item.updatedBy !== item.createdBy ? authorLabel(item.updatedBy, me) : '';
    parts.push(`изменено ${memoryDate(item.updatedAt)}${editor ? ` (${editor})` : ''}`);
  }
  return parts;
}
